import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { post } from '../../api/apiBridges/httpBridge';
import { ffetch }  from '../../api/customHttp';
import { post } from "api/apiBridges/httpBridge";


// Глобальная переменная для хранения функции получения состояния
let getStateFunction = null;

// Функция для установки ссылки на функцию получения состояния Redux
export const setReduxStateGetter = (getStateFn) => {
  getStateFunction = getStateFn;
};

// Функция для получения user_id из любого места в приложении
export const getUserId = () => {
  if (!getStateFunction) {
    console.warn("Redux state getter function not set. Call setReduxStateGetter first.");
    return null;
  }
  
  try {
    const state = getStateFunction();
    return state.login.user_id;
  } catch (error) {
    console.error("Error getting user_id from state:", error);
    return null;
  }
};


export const loginUser = createAsyncThunk(
    "users/login",
    async ({ login, password }, thunkAPI) => {
        try {
            const data = await (await fetch(`${process.env.REACT_APP_DEV_HOST_CORE}/auth/login`, {
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                },
                body: JSON.stringify({username:login, password:password}),
                method: 'POST',
            })).json();
            if (data.accessToken) {
                localStorage.setItem('access_token', data.accessToken);
                localStorage.setItem('refresh_token', data.refreshToken);
                localStorage.setItem('user_id', data.user_id);
                localStorage.setItem('role', data.role);
                localStorage.setItem('sub_id', data.sub_id);
                return {
                    access_token: data.accessToken, 
                    role: data.role, 
                    user_id:data.user_id, 
                    sub_id: data.sub_id,
                    company_id:data.company_id, 
                    isSuccess: true,
                    isError: false,
                    rules: data.rules
                };
            }
            else {
                return {
                    access_token: undefined, 
                    role: undefined, 
                    user_id:undefined, 
                    sub_id: undefined,
                    company_id:undefined, 
                    isSuccess: false,
                    isError: true,
                    errType: "dataError",
                    rules: []
                };
            }
        } catch (e) {
            console.log("Error", e.response.data);
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const seamlesAuth = createAsyncThunk(
    "users/login",
    async ({ uid, seluid, sub_id }, thunkAPI) => {
        try {
            console.log(uid, seluid)
            const data = await post('auth/seamlesAuth', {uid, seluid, sub_id})
            if (data.accessToken) {
                localStorage.setItem('access_token', data.accessToken);
                localStorage.setItem('refresh_token', data.refreshToken);
                localStorage.setItem('user_id', data.user_id);
                localStorage.setItem('role', data.role);
                localStorage.setItem('sub_id', data.sub_id);
                return {
                    access_token: data.accessToken, 
                    role: data.role, 
                    user_id:data.user_id, 
                    sub_id: data.sub_id,
                    company_id:data.company_id, 
                    isSuccess: true,
                    isError: false,
                    rules: data.rules
                };
            }
            else {
                return {
                    access_token: undefined, 
                    role: undefined, 
                    user_id:undefined, 
                    sub_id: undefined,
                    company_id:undefined, 
                    isSuccess: false,
                    isError: true,
                    errType: "dataError",
                    rules: []
                };
            }
        } catch (e) {
            console.log("Error", e.response.data);
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

//Тут надо будет проверять на присутсвие токена в локал сторадже
//в целом переписать логику функции

export const isLogged = createAsyncThunk(
    "users/islogged",
    async (_, thunkAPI) => {
        try {
            console.log("CHECK0")
            let refresh_token = localStorage.getItem('refresh_token')
            let user_id = localStorage.getItem('user_id')
            let role = localStorage.getItem('role')
            let sub_id = localStorage.getItem('sub_id')
            console.log("CHECK", refresh_token, user_id, role)
            if (refresh_token && user_id && role) {
                const data = await (await ffetch(`${process.env.REACT_APP_DEV_HOST_CORE}/auth/checkAuth`, {
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                    },
                    body: JSON.stringify({ refreshToken: refresh_token, userId: user_id, role, sub_id }),
                    method: 'POST',
                })).json();            
                console.log("data", data)
                if (data.accessToken) {
                    localStorage.setItem('access_token', data.accessToken);
                    localStorage.setItem('refresh_token', data.refreshToken);
                    localStorage.setItem('user_id', data.user_id);
                    localStorage.setItem('role', data.role);
                    localStorage.setItem('sub_id', data.sub_id);
                    return {
                        access_token: data.accessToken, 
                        role: data.role, 
                        user_id:data.user_id, 
                        sub_id: data.sub_id,
                        company_id:data.company_id, 
                        isSuccess: true,
                        isError: false,
                        rules: data.rules
                    };
                }
                else {
                    return {
                        access_token: undefined, 
                        role: undefined, 
                        user_id:undefined, 
                        sub_id: undefined,
                        company_id:undefined, 
                        isSuccess: false,
                        isError: true,
                        errType: "dataError",
                        rules: []
                    };
                }
            }
            else {
                return {
                    access_token: undefined, 
                    role: undefined, 
                    user_id:undefined, 
                    sub_id: undefined,
                    company_id:undefined, 
                    isSuccess: false,
                    isError: true,
                    errType: "dataError",
                    rules: []
                };
            }

        } catch (e) {
            console.log("Error", e.response.data);
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const LoginSlice = createSlice({
    name: "login",
    initialState: {
        token: "",
        isSuccess: false,
        isFetching: true,
        isError: false,
        errorMessage: "",
        role: undefined,
        user_id: null,  
        sub_id: undefined,    
        company_id: null,
        errType: undefined,
        rules: []
    },
    reducers: {
        clearState: (state) => {
            state.isError = false;
            state.isSuccess = false;
            state.isFetching= false;
            return state;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginUser.fulfilled, (state, { payload }) => {
                state.token = payload.access_token;
                state.isFetching = false;
                state.isSuccess = payload.isSuccess;
                state.isError = payload.isError;
                state.role = payload.role;
                state.user_id = payload.user_id;       
                state.sub_id = payload.sub_id;       
                state.company_id = payload.company_id;   
                state.errType = payload.errType;
                state.rules = payload.rules
                return state;
            })
            .addCase(isLogged.fulfilled, (state, { payload }) => {
                state.token = payload.access_token;
                state.isFetching = false;
                state.isSuccess = payload.isSuccess;
                state.isError = payload.isError;
                state.role = payload.role;
                state.user_id = payload.user_id;   
                state.sub_id = payload.sub_id;    
                state.company_id = payload.company_id;   
                state.rules = payload.rules
                return state;
            })
            .addCase(loginUser.rejected, (state, { payload }) => {
                state.isFetching = false;
                state.isError = true;
                state.errorMessage = payload?.message || "Login fail" ;
                state.errType = "coreError"
            })
            .addCase(loginUser.pending, (state) => {
                state.isFetching = true;
            })
            .addCase(isLogged.pending, (state) => {
                console.log("isLogged.pending - начинаем проверку");
                state.isFetching = true;
            })
            .addCase(isLogged.rejected, (state, { payload }) => {
                console.log("isLogged.rejected - ошибка:", payload);
                state.isFetching = false;
                state.isError = true;
                state.isSuccess = false;
                state.errorMessage = payload?.message || "Ошибка проверки авторизации";
                state.errType = payload?.type || "coreError";
            })
    }
})

export const { clearState } = LoginSlice.actions;

export const loginSelector = (state) => state.login;